import Box from '@mui/material/Box';
import React, { useEffect, useMemo, useState } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { OnboardDevices } from './OnboardDevices';
import { Tab, Tabs } from '@mui/material';
import { hasAllowedRole } from '../utils/hasAllowedRole';
import { UserRoles } from '../interfaces';
import { ROUTES_CONFIGS } from '../config';
import { useCognitoUser } from '../hooks/useCognitoUser';
import { OnboardDevicesHardwareConfigurations } from './OnboardDevicesHardwareConfigurations';
import { OnboardDevicesOnline } from './OnboardDevicesOnline';
import { OnboardDevicesRouteCards } from './OnboardDevicesRouteCards';

export const Devices = () => {
    const [tabValue, setTabValue] = useState<number | null>(0);
    const { userRoles } = useCognitoUser();
    const navigate = useNavigate();

    const routes = useMemo(() => {
        if (userRoles && hasAllowedRole(userRoles, [UserRoles.ADMINS])) {
            return [
                ROUTES_CONFIGS.ONBOARD_DEVICES,
                ROUTES_CONFIGS.ONBOARD_DEVICES_HARDWARE,
                ROUTES_CONFIGS.ONBOARD_DEVICES_ONLINE,
                ROUTES_CONFIGS.ONBOARD_DEVICES_ROUTE_CARDS,
            ];
        }

        return [];
    }, userRoles ?? []);

    useEffect(() => {
        const activeTabIndex = routes.findIndex((route) => location.pathname.split('/').pop() === route.path);
        if (activeTabIndex !== -1) {
            setTabValue(activeTabIndex);
        }
    }, [location.pathname, routes]);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
        navigate(`/app/devices/${routes[newValue].path}`);
    };

    return (
        <>
            <Box sx={{ borderBottom: 1, p: 2, pb: 0, borderColor: 'divider' }}>
                <Tabs value={tabValue} onChange={handleChange}>
                    {routes.map((route) => (
                        <Tab label={route.label} key={route.path} />
                    ))}
                </Tabs>
            </Box>
            <Box sx={{ p: 2 }}>
                <Routes>
                    <Route path="onboard-devices" element={<OnboardDevices />} />
                    <Route
                        path="onboard-devices-hardware"
                        element={<OnboardDevicesHardwareConfigurations />}
                    />
                    <Route path="onboard-devices-online" element={<OnboardDevicesOnline />} />
                    <Route path="onboard-devices-route-cards" element={<OnboardDevicesRouteCards />} />
                    <Route path="*" element={<Navigate to="onboard-devices" replace />} />
                </Routes>
            </Box>
        </>
    );
};
